/* ==========================================================================
   Modal > Client > Config
   ========================================================================== */

/* Base config */
const config = {
    component: 'Modal',
    init: true,
    hasClose: true,
    autoDom: true,
    autoStore: true,
    isLoading: false,
    triggers: [],
    type: 'modal-type',
    cssVisible: 'is-visible',
    cssModalBody: 'modal-is-visible',
    modalClose: 'data-modal-close'
};

/* Not close config */
const notClose = {
    hasClose: false
};

const getConfig = (type = '') => {
    if (type === 'notClose') return { ...config, ...notClose };

    return { ...config };
};

module.exports = getConfig;
